export default {
environment: 'production',
ENV: 'production',
};
